import { SIDE_TABLE_COLUMN_TYPES, tableSideColumnMapper } from "@loanbossinc/component-library";
import { defaultField, formatDate, defaultPercentField } from "helpers/row-logic-helper";

import { shouldShowField } from "../loanDetailEditUtil";

import { shouldShowPrincipalReduction, shouldShowAmortizationTerm, shouldShowAmortizationRate } from "./section-loan-extension-rows-logic";

const DEFAULT_WIDTH = 138;

export const rows = {
  noticePeriod: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Notice Period",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING_SUBTEXT,
        map: data => {
          const extensionNoticeMin = defaultField(data, "extensionNoticeMin");
          const extensionNoticeMax = defaultField(data, "extensionNoticeMax");

          return `${extensionNoticeMin} - ${extensionNoticeMax} days`;
        },
        subtextMappers: [
          {
            map: data => {
              const extensionNoticeMinDate = defaultField(data, "extensionNoticeMinDate");
              const formattedNoticeMinDate = formatDate(extensionNoticeMinDate);

              const extensionNoticeMaxDate = defaultField(data, "extensionNoticeMaxDate");
              const formattedNoticeMaxDate = formatDate(extensionNoticeMaxDate);

              return `Due by ${formattedNoticeMinDate}, Can submit on ${formattedNoticeMaxDate}`;
            }
          }
        ],
        Cell: tableSideColumnMapper
      }
    ]
  },

  minimumQualifications: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        className: "subsection",
        width: DEFAULT_WIDTH,
        label: "minimum qualifications",
        Cell: tableSideColumnMapper,
        colSpan: 2
      }
    ]
  },

  ltv: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "ltv",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.PERCENT,
        map: loan => defaultPercentField(loan, "extensionLtv", 100),
        Cell: tableSideColumnMapper,
        decimals: 2
      }
    ]
  },

  dscr: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "dscr",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DECIMAL,
        map: data => defaultField(data, "extensionDscr"),
        Cell: tableSideColumnMapper,
        decimals: 2,
        suffix: data => "x"
      }
    ]
  },

  debtYield: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "debt Yield",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.PERCENT,
        map: loan => defaultPercentField(loan, "extensionDebtYield", 100),
        Cell: tableSideColumnMapper,
        decimals: 3
      }
    ]
  },

  amortization: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        className: "subsection",
        width: DEFAULT_WIDTH,
        label: "amortization",
        Cell: tableSideColumnMapper,
        colSpan: 2
      }
    ]
  },

  type: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "type",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.STRING,
        map: data => defaultField(data, "extensionAmortizationType.name"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  amortizationTerm: {
    isVisible: data => shouldShowAmortizationTerm(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Amortization Term",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DECIMAL,
        map: data => defaultField(data, "extensionAmortizationTerm"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  amortizationRate: {
    isVisible: data => shouldShowAmortizationRate(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Amortization Rate",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.PERCENT,
        map: loan => defaultPercentField(loan, "extensionAmortizationRate", 100),
        Cell: tableSideColumnMapper,
        decimals: 3
      }
    ]
  },
  amortizationTerm: {
    isVisible: data => shouldShowAmortizationTerm(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Amortization Term",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DECIMAL,
        map: data => defaultField(data, "extensionAmortizationTerm"),
        Cell: tableSideColumnMapper
      }
    ]
  },
  principalReduction: {
    isVisible: data => shouldShowPrincipalReduction(data),
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Principal Reduction",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.DOLLAR,
        map: data => defaultField(data, "extensionAmortizationPrincipalReduction"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  feesAndMiscellaneous: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        className: "subsection",
        label: "fees and miscellaneous",
        Cell: tableSideColumnMapper,
        colSpan: 2
      }
    ]
  },

  qualifications: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "qualifications",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => defaultField(data, "extensionQualifications"),
        Cell: tableSideColumnMapper
      }
    ]
  },

  extensionFee: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "extension Fee",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.PERCENT,
        map: loan => defaultPercentField(loan, "extensionFee", 100),
        Cell: tableSideColumnMapper,
        decimals: 3
      }
    ]
  },

  misc: {
    cells: [
      {
        type: SIDE_TABLE_COLUMN_TYPES.COLUMN,
        width: DEFAULT_WIDTH,
        label: "Misc.",
        Cell: tableSideColumnMapper
      },
      {
        type: SIDE_TABLE_COLUMN_TYPES.TEXT,
        map: data => defaultField(data, "extensionMisc"),
        Cell: tableSideColumnMapper
      }
    ]
  }
};
